import React, { useMemo, useState } from 'react';
import { useOutboundCall } from '@api/hooks/useOutboundCall';
import useCallingDisabled from '@lib/hooks/useCallingDisabled';
import useAuth from '@modules/AuthModule/hooks/useAuth';
import usePhoneState from '@modules/SoftPhoneModule/usePhoneState';
import { OutboundCallModalContext } from './OutboundCallModalContext';
import { initialCallDetails } from './contants';
import { OutboundCallDetails } from '../types';

type Props = {
  children: React.ReactNode;
};

export const OutboundCallModalProvider = ({ children }: Props) => {
  const [callToDetails, setCallToDetails] =
    useState<OutboundCallDetails>(initialCallDetails);

  const [callFromDetails, setCallFromDetails] =
    useState<OutboundCallDetails>(initialCallDetails);

  const { user } = useAuth();
  const { phoneConnected, disconnectTriggeredLocally } = usePhoneState();
  const { callingDisabled } = useCallingDisabled();
  const { outboundCall, isProcessingCall } = useOutboundCall();

  const value = useMemo(() => {
    // TODO: revisit the validation for dialpad number to support more than 10 digits international numbers
    const callButtonEnabled =
      callToDetails.number.length > 0 &&
      !callingDisabled &&
      (phoneConnected || disconnectTriggeredLocally);

    return {
      callToDetails,
      callFromDetails,
      setCallToDetails,
      setCallFromDetails,
      callButtonEnabled,
      phoneConnected,
      outboundCallsAllowed: user?.outboundCallsAllowed ?? false,
      from: {
        name: callFromDetails.callDisplayName,
        number: callFromDetails.number,
      },
      to: {
        name: callToDetails.callDisplayName,
        number: callToDetails.number,
        agentId: callToDetails.agentId,
      },
      outboundCall,
      isProcessingCall,
    };
  }, [
    callToDetails,
    callFromDetails,
    callingDisabled,
    phoneConnected,
    user?.outboundCallsAllowed,
    outboundCall,
    isProcessingCall,
    disconnectTriggeredLocally,
  ]);

  return (
    <OutboundCallModalContext.Provider value={value}>
      {children}
    </OutboundCallModalContext.Provider>
  );
};
